const ViewMax = {
  XSm: 360,
  Sm: 600,
  Md: 960,
  Lg: 1440,
  XLg: 1920
};

export default ViewMax;
